import { ConfigurationExchangeInfo } from "@shared/types";
import { useContext, useEffect, useMemo, useState } from "react";
import { AccountFormContext } from "@shared/features/common/AccountForm.context";
import { toggleArrayItem } from "@shared/utils/arrays";
import { mapValues, uniq } from "lodash";
import { QuickConnectContext } from "@shared/features/onboarding/QuickConnect.context";

const useSelectExchange = () => {
  const { exchangesData, aggExchanges, exchangesLoading } =
    useContext(AccountFormContext)!;
  const { onBackToSelectExchange, isInitialized } =
    useContext(QuickConnectContext) || {};
  const [filters, setFilters] = useState<string[]>([]);

  const getExchangeTags = (exchanges?: ConfigurationExchangeInfo[]) => {
    const tags: string[] = [];
    exchanges?.forEach((exchange) => {
      if (!!exchange.tag) tags.push(exchange.tag);
    });
    return uniq(tags);
  };

  const exchangeToTags = useMemo(() => {
    return mapValues(aggExchanges, (exchanges) => getExchangeTags(exchanges));
  }, [aggExchanges]);

  const filteredExchanges = useMemo(() => {
    if (!filters.length) return Object.entries(exchangeToTags);
    return Object.entries(exchangeToTags).filter(([_, tags]) =>
      tags.some((tag) => filters?.includes(tag))
    );
  }, [filters, exchangeToTags]);

  const filtersTags = useMemo(
    () => getExchangeTags(exchangesData),
    [exchangesData]
  );

  const onFilterClick = (filterName: string) => {
    setFilters(toggleArrayItem(filters, filterName));
  };

  const getIsFilterSelected = (filterName: string) => {
    return filters?.includes(filterName);
  };

  const filtersData = {
    filtersTags,
    onClick: onFilterClick,
    getIsSelected: getIsFilterSelected,
  };

  useEffect(() => {
    if (isInitialized) {
      onBackToSelectExchange?.();
    }
  }, [isInitialized]);

  return {
    exchangesLoading,
    filteredExchanges,
    filtersData,
  };
};

export default useSelectExchange;
